import { RiCalendarLine, RiHistoryLine, RiTicketLine } from "@remixicon/react";
import { Card } from "@workspace/ui/components/card";

interface ShowsEmptyStateProps {
	variant: "now" | "upcoming" | "past" | "all";
}

export function ShowsEmptyState({ variant }: ShowsEmptyStateProps) {
	const config = {
		now: {
			icon: RiTicketLine,
			title: "No Shows Happening Now",
			message:
				"There are no shows happening right now or in the immediate future.",
		},
		all: {
			icon: RiTicketLine,
			title: "No Shows Available",
			message: "There are no shows available at the moment.",
		},
		upcoming: {
			icon: RiCalendarLine,
			title: "No Upcoming Shows",
			message: "Check back later for upcoming concerts and events.",
		},
		past: {
			icon: RiHistoryLine,
			title: "No Past Shows",
			message: "Past events will be displayed here once available.",
		},
	};

	const { icon: Icon, title, message } = config[variant];

	return (
		<Card className="p-8 text-center">
			<div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
				<Icon className="h-6 w-6 text-muted-foreground" />
			</div>
			<h3 className="mb-1 font-semibold text-xl">{title}</h3>
			<p className="text-muted-foreground text-sm">{message}</p>
		</Card>
	);
}
